var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.svgComponent)?_c(_vm.svgComponent,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"fill":_vm.fill}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }